export enum EditUserFields {
  firstName = 'firstName',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  productRegionPreference = 'productRegionPreference',
  assignedOffice = 'assignedOffice',
  assignedLocationIds = 'assignedLocationIds',
  assignedRegionIds = 'assignedRegionIds',
}
